import React from 'react';
import Header from './Header';
import Footer from './Footer';

/**
 * Main layout component that wraps the application content
 * 
 * This component provides a consistent layout structure for the application,
 * including the header and footer components. It uses a flex column layout
 * to ensure the footer stays at the bottom of the page, even when content
 * doesn't fill the viewport.
 * 
 * Features:
 * - Consistent header across all pages
 * - Main content area that grows to fill available space
 * - Footer that stays at the bottom
 * - Minimum height set to viewport height
 * 
 * Usage:
 * ```jsx
 * <Layout>
 *   <YourPageContent />
 * </Layout>
 * ```
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The content to be rendered in the main section
 */
const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Header component with navigation and theme toggle */}
      <Header />
      
      {/* Main content area that grows to fill available space */}
      <main className="flex-grow">
        {children}
      </main>
      
      {/* Footer component with links and copyright information */}
      <Footer />
    </div>
  );
};

export default Layout; 
